import React, { Component } from "react";
import { Form } from "react-form";

import InputText from "components/form-fields/InputText";
import PermissionCheckLists from "./PermissionCheckLists";

export default class extends Component {
  onSubmit = data => {
    this.props.handleFormSubmit(data);
  };

  render() {
    const { defaultValues } = this.props;
    console.log({ defaultValues });

    return (
      <Form onSubmit={this.onSubmit} defaultValues={defaultValues}>
        {formApi => (
          <form onSubmit={formApi.submitForm}>
            <div className="box">
              <div className="columns">
                <div className="column">
                  <InputText required field="name" label="Name" placeholder="Name" />
                </div>
                <div className="column">
                  <InputText required field="slug" label="Slug" placeholder="Slug" />
                </div>
              </div>
            </div>
            <PermissionCheckLists permissions={this.props.permissions} />
            <button className="button is-fullwidth is-info is-medium">Submit</button>
          </form>
        )}
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Role/Form/index.js